module.exports = __webpack_public_path__ + "media/images/partners/house_of_europe_2-00755aa85ed08fd7a4746427120f742b.png";